<template>
    <div>
        <el-date-picker v-model="date" type="daterange" clearable=false align="right" @change="change" placeholder="选择日期范围" :picker-options="pickerOptions">
        </el-date-picker>
    </div>
</template>

<script>
export default {
  name: 'DoubleDate',
  watch: {
    modelData: function (val, oldVal) {
      if (val == '') {
        this.date = []
      }
    }
  },
  data () {
    var year = new Date().getFullYear()
    var that = this
    return {
      date: '',
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
                        // start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '本年度',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(new Date(start.getFullYear() + '/01/01'))
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '上年度',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(new Date((start.getFullYear() - 1) + '/01/01'))
            end.setTime(new Date(end.getFullYear() + '/01/01'))
            end.setTime(new Date(end - 1000 * 60 * 60 * 24))
            picker.$emit('pick', [start, end])
          }
        }, {
          text: (year - 2) + '年度',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(new Date((start.getFullYear() - 2) + '/01/01'))
            end.setTime(new Date((start.getFullYear() + 1) + '/01/01'))
            end.setTime(new Date(end - 1000 * 60 * 60 * 24))
            picker.$emit('pick', [start, end])
          }
        }, {
          text: (year - 3) + '年度',
          onClick (picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(new Date((start.getFullYear() - 3) + '/01/01'))
                end.setTime(new Date((start.getFullYear() + 1) + '/01/01'))
                end.setTime(new Date(end - 1000 * 60 * 60 * 24))
                picker.$emit('pick', [start, end])
              }
        }]
      }
    }
  },
  props: {
    endKey: {
      type: String,
      default: 'end'
    },
    startKey: {
      type: String,
      default: 'start'
    },
    data: {
      type: Object
    },
    modelKey: {
      type: String,
      default: 'date'
    },
    modelData: {}
  },
  methods: {
    change (val) {
      if (val) {
        var d = new Date(val[0])
        var b = new Date(val[1])
        var startYouWant = d.getFullYear() + '-' + this.getDateN(d.getMonth() + 1) + '-' + this.getDateN(d.getDate())
        var endYouWant = b.getFullYear() + '-' + this.getDateN(b.getMonth() + 1) + '-' + this.getDateN(b.getDate())
                //    this.data[this.modelKey]=startYouWant+'-'+endYouWant;
        this.data[this.startKey] = startYouWant
        this.data[this.endKey] = endYouWant
      } else {
        this.data[this.startKey] = ''
        this.data[this.endKey] = ''
      }
    },
    getDateN (date) {
      date = (date < 10) ? (date = '0' + date) : date
      return date
    }

  },
  created () {

  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/utils/DoubleDate.vue?139186b0